import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { PipelineStepWrapper } from './';
import * as ActionTypes from 'constants';

class PipelineAction extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const {action, job} = this.props;
    let completed = false;
    let link_to = ``;
    switch (action.type) {
      case ActionTypes.START_CREATE_INCIDENT:
        if(this.props.job.damage_incident) {
          completed = true;
          link_to = `/client/${job.client ? job.client._id || job.client : ''}/incidents/${this.props.job.damage_incident._id || this.props.job.damage_incident}`
        }
        break;
      default:

    }
    return <PipelineStepWrapper completed={completed}>
      {completed ? (
        <Link to={link_to} className="btn btn-lg btn-info">View {this.props.label}</Link>
      ) : <div onClick={e => this.props.dispatch(action)} className=" btn btn-lg btn-primary"><i className="fa fa-external-link"></i>Create {this.props.label}</div>}
    </PipelineStepWrapper>
  }
}

export default connect()(PipelineAction);



// WEBPACK FOOTER //
// ./src/browser/components/pipeline/pipeline-action.js